<template>
  <div></div>
</template>

<script>
import config from "@/config.json";

export default {
  name: "SetToken",
  created() {
    this.handleSetToken();
  },
  methods: {
    handleSetToken() {
      try {
        const hostApi = config.hostApi;
        const hostApiDulich = config.hostApiDuLich + "api/dulich/v1/";
        const allowedDomains = [
          config.urlAdmin,
          config.urlClient,
          config.urlClientEn,
        ];

        const params = new URLSearchParams(window.location.search);
        const rawToken = params.get("$token");
        const token = rawToken ? decodeURIComponent(rawToken) : null;

        if (token) {
          if (hostApi) {
            localStorage.setItem(`mushroom.tokens[${hostApi}]`, token);
          }
          if (hostApiDulich) {
            localStorage.setItem(`mushroom.tokens[${hostApiDulich}]`, token);
          }
        }

        const lang = params.get("lang");
        if (lang) {
          localStorage.setItem("lang", lang);
        }

        const callbackUrl = params.get("callbackUrl");
        this.redirectTo(callbackUrl, allowedDomains);
      } catch {
        window.location.href = "/";
      }
    },
    isAllowedUrl(url, allowedDomains) {
      try {
        const fullUrl = /^https?:\/\//i.test(url)
          ? url
          : `https://${url.replace(/^\/\//, "")}`;
        const { hostname } = new URL(fullUrl);

        return allowedDomains.some((domain) => {
          if (!domain) return false;
          const cleanDomain = domain
            .replace(/^https?:\/\//i, "")
            .replace(/\/$/, "");
          return hostname === cleanDomain;
        });
      } catch {
        return false;
      }
    },
    redirectTo(url, allowedDomains) {
      if (!url || url === "undefined") {
        window.location.href = "/";
        return;
      }
      if (this.isAllowedUrl(url, allowedDomains)) {
        window.location.href = url;
      } else {
        window.location.href = "/";
      }
    },
  },
};
</script>
